import { useEffect, useRef, useState } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../../../config/espFirebaseConfig";

/**
 * Subscribes to idleState/{deviceId} in Firebase RTDB.
 * Returns { idle, tick } and fires onTick(idle, tick) whenever tick increases.
 */
export default function useIdleState(deviceId, onTick) {
  const [state, setState] = useState({ idle: null, tick: null });
  const prevTickRef = useRef(null);
  const onTickRef = useRef(onTick);

  useEffect(() => {
    onTickRef.current = onTick;
  }, [onTick]);

  useEffect(() => {
    if (!deviceId) return;

    const dbRef = ref(database, `idleState/${deviceId}`);

    const unsub = onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) return;

      const { idle, tick } = data;
      setState({ idle, tick });

      if (prevTickRef.current !== null && tick > prevTickRef.current) {
        onTickRef.current?.(idle, tick);
      }

      prevTickRef.current = tick;
    });

    return () => unsub();
  }, [deviceId]);

  return state;
}
